import React, { Component } from 'react'
import PropTypes from 'prop-types'

class LaunchDelaySetting extends Component {
    constructor(props) {
        super(props)

        this.state = { value: this.props.value }
    }

    updateState = (newValue) => {
        const d = parseInt(newValue, 10)
        if (d === this.state.value) {
            return
        }

        this.setState({ value: d })
    }

    saveSetting = (newValue) => {
        // Update the value displayed next to the slider
        const d = parseInt(newValue, 10)
        if (d === this.props.value) {
            return
        }

        this.props.update(d)
    }

    render() {
        const rangeStyle = {
            backgroundSize: `${this.state.value / this.props.multiplier}% 100%`,
        }

        return (
            <label htmlFor="launch-delay">
                <p>{this.props.label}</p>
                <input
                    type="range"
                    min="0"
                    max={this.props.multiplier * 100}
                    value={this.state.value}
                    onChange={event => this.updateState(event.target.value)}
                    onMouseUp={event => this.saveSetting(event.target.value)}
                    step="1"
                    id="launch-delay"
                    style={rangeStyle}
                    placeholder={this.props.label}
                />
                <p>
                    {this.state.value} {this.props.seconds}
                </p>
            </label>
        )
    }
}

LaunchDelaySetting.propTypes = {
    label: PropTypes.string,
    seconds: PropTypes.string,
    multiplier: PropTypes.number,
    value: PropTypes.number,
    update: PropTypes.func,
}

LaunchDelaySetting.defaultProps = {
    multiplier: 1.2,
}

export default LaunchDelaySetting



// WEBPACK FOOTER //
// ./src/features/Settings/components/Settings/components/LaunchDelay/component.js